module.exports = __webpack_public_path__ + "4ee37accecd67d0227cb71ca6fde15e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/car.png
// module id = 2619
// module chunks = 0